import { Box } from '@mui-core-real';
import React from 'react';
import { createStyles, makeStyles } from '@mui-core-real/styles';
import { BaseButton } from '@components/BaseButton/BaseButton';

const useStyles = makeStyles((theme) =>
	createStyles({
		button: {
			maxHeight: '48px',
			padding: theme.spacing(2, 1.5),
		},
		buttonRow: {
			display: 'flex',
			justifyContent: 'flex-end',
			gap: theme.spacing(1.25),
		},
	}),
);

interface CancelCaseModalActionsProps {
	onDismissClick: () => void;
	onCancelClick?: () => void;
}

export const CancelCaseModalActions = ({ onDismissClick, onCancelClick }: CancelCaseModalActionsProps) => {
	const classes = useStyles();

	return (
		<Box className={classes.buttonRow}>
			<BaseButton
				className={classes.button}
				dataField="cancelCase-modal-dismissBtn"
				id="backButton"
				onClick={onDismissClick}
				variant="outlined"
				color="primary"
			>
				Dismiss
			</BaseButton>
			<BaseButton
				className={classes.button}
				dataField="cancelCase-modal-cancelCaseBtn"
				color="destructive"
				id="cancelCaseButton"
				type="submit"
				variant="contained"
				onClick={onCancelClick}
			>
				Cancel Case
			</BaseButton>
		</Box>
	);
};
